import { render } from "./SideBarNav.vue?vue&type=template&id=2de52acd&scoped=true"
import script from "./SideBarNav.vue?vue&type=script&lang=js"
export * from "./SideBarNav.vue?vue&type=script&lang=js"

import "./SideBarNav.vue?vue&type=style&index=0&id=2de52acd&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de52acd"]])

export default __exports__